module.exports = __webpack_public_path__ + "img/index_play_white.ec26088b.svg";